import gql from "graphql-tag";

const query = gql`
  query Contract($contractId: ID) {
    contract(contractId: $contractId) {
      id
      customerId
      deploymentId
      hasRoomTemplates
      localRecAvailable
      recordAndShareAvailable
      tiiviiOttConfig {
        enabled
        webhookUrl
        nimbleConfigUrl
      }
    }
  }
`;

export default contractId => ({
  query,
  skip: !contractId,
  variables: { contractId },
});
